import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { LookbookButton } from '@fuww/library/src/Lookbook/Upload';
import Loader from '../Loader';
import { Router } from '../../routes.mjs';
import { AuthConsumer } from '../AuthProvider';
import { saveRouterState } from '../../lib/routerState';

const Authorized = ({ children }) => {
  const router = useRouter();

  return (
    <AuthConsumer>
      {({ user, loading }) => {
        if (loading) {
          return (
            <Loader />
          );
        }

        if (!user && process.browser) {
          return (
            <LookbookButton
              id="lookbook-login"
              onClick={() => {
                saveRouterState(router);
                Router.replaceRoute('login');
              }}
              required
            />
          );
        }

        return children;
      }}
    </AuthConsumer>
  );
};

Authorized.propTypes = {
  children: PropTypes.node,
};

Authorized.defaultProps = {
  children: null,
};

export default Authorized;
